<template>
  <el-table
    class="k-starts-organizers-list"
    :data="organizers"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <!-- <el-table-column label="Активна" width="100">
      <template slot-scope="scope">
        <el-tooltip :content="'Акция ' + value" placement="top">
          <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="true"
            inactive-value="false"
            @change="handleChangeActiveStatus()"
          >
          </el-switch>
        </el-tooltip>
      </template>
    </el-table-column> -->

    <el-table-column
      class="k-starts-organizers-list__value"
      prop="_id"
      label="id"
      width="250"
    >
    </el-table-column>

    <el-table-column
      class="k-starts-organizers-list__value"
      prop="title"
      label="Назва"
    >
    </el-table-column>

    <el-table-column
      class="k-starts-organizers-list__value"
      prop="id"
      label="Ідентифікатор"
    >
    </el-table-column>

   <el-table-column label="Action" width="100">
      <template slot-scope="scope">
        <el-tooltip content="Редактировать" placement="top">
          <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-starts-organizers-list - Отображает список точек карты

*
* @version 1.0.0
*/

import formatDate from '@/util/formatDate';

export default {
  name: 'k-starts-organizers-list',

  props: {
    // Массив всех точек
    organizers: {
      type: Array,
    },
  },

  methods: {
    // Класс для стрки, используется для расскарски строк таблицы в разные цвета
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    // Редактирование точки
    handleEdit(data) {
      this.$emit('edit', data._id)
    },

    // Удаление точки
    handleDelete(data) {
      this.$emit('delete', data._id);
    },

    // Форматирование даты
    formatDate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-points-lis {
  $this: &;

  &__value {
    font-size: 10px;
  }
}
</style>
